<div class="boxItem" (click)="clickItem.emit()">
	<p class="boxItem__text">{{ text }}</p>
	<i [class]="icon" class="boxItem__icon"></i>
</div>
